import React from "react";
import "./Sidebar.css";
import { NavLink } from "react-router-dom";

import logo from "../assets/logo.png";
import sideImage from "../assets/image.png";

import {
  FaTachometerAlt,
  FaCar,
  FaIdCard,
  FaAddressCard,
  FaWallet,
  FaListAlt,
  FaUserCircle,
  FaUsersCog,
  FaUserPlus,
  FaExchangeAlt,
  FaBell,
  FaTools,
  FaTags,
  FaHeadset,
  FaSignOutAlt
} from "react-icons/fa";

const Sidebar = ({ user }) => {

  const isAdmin = user?.user_type === "admin";

  return (
    <div className="sidebar">

      <div className="sidebar-logo">
        <img src={logo} alt="RC Finder" />
      </div>

      <div className="menu-container">
        <ul className="menu">

          {/* ⭐ Dashboard */}
          <li>
            <NavLink to="/dashboard" className="menu-link">
              <FaTachometerAlt style={{ color: "#007bff" }} /> Dashboard
            </NavLink>
          </li>

          {/* ⭐ RC Services */}
          <li>
            <NavLink to="/dashboard/rc-services" className="menu-link">
              <FaCar style={{color:"#ff0000"}} /> RC Services
            </NavLink>
          </li>

          {/* ⭐ DL */}
          <li>
            <NavLink to="/dashboard/dl-services" className="menu-link">
              <FaIdCard style={{color:"#0066ff"}} /> DL Services
            </NavLink>
          </li>

          {/* ⭐ PAN */}
          <li>
            <NavLink to="/dashboard/pan-services" className="menu-link">
              <FaAddressCard style={{color:"#ff9900"}} /> PAN Services
            </NavLink>
          </li>

          {/* ⭐ Wallet */}
          <li>
            <NavLink to="/dashboard/add-money" className="menu-link">
              <FaWallet style={{color:"#00aa2b"}} /> Wallet
            </NavLink>
          </li>

          {/* ⭐ Printed List */}
          <li>
            <NavLink to="/dashboard/printed-list" className="menu-link">
              <FaListAlt style={{color:"#8a2be2"}} /> All Printed Records
            </NavLink>
          </li>

          {/* ⭐ Profile */}
          <li>
            <NavLink to="/dashboard/profile" className="menu-link">
              <FaUserCircle style={{color:"#444"}} /> Profile
            </NavLink>
          </li>

          {/* ================= ADMIN MENU ================= */}
       {isAdmin && (
  <>
    <li>
      <NavLink to="/dashboard/usermanagement" className="menu-link">
        <FaUsersCog style={{color:"#007bff"}} /> User Management
      </NavLink>
    </li>

    <li>
      <NavLink to="/dashboard/add-user" className="menu-link">
        <FaUserPlus style={{color:"#28a745"}} /> Add User
      </NavLink>
    </li>

    <li>
      <NavLink to="/dashboard/balance-transfer" className="menu-link">
        <FaExchangeAlt style={{color:"#ff7b00"}} /> Balance Transfer
      </NavLink>
    </li>

    <li>
      <NavLink to="/dashboard/notification" className="menu-link">
        <FaBell style={{color:"#ff004c"}} /> Notification
      </NavLink>
    </li>

    <li>
      <NavLink to="/dashboard/service-access" className="menu-link">
        <FaTools style={{color:"#009688"}} /> Service Access
      </NavLink>
    </li>

    <li>
      <NavLink to="/dashboard/pricing" className="menu-link">
        <FaTags style={{color:"#aa00ff"}} /> Pricing List
      </NavLink>
    </li>
  </>
)}


          {/* ⭐ Support */}
          <li>
            <NavLink to="/dashboard/support" className="menu-link">
              <FaHeadset style={{color:"#0066ff"}} /> Support
            </NavLink>
          </li>

          {/* ⭐ Logout */}
          <li>
            <NavLink
              to="/"
              className="menu-link"
              onClick={() => localStorage.removeItem("user")}
            >
              <FaSignOutAlt style={{ color: "#000" }} /> Logout
            </NavLink>
          </li>

        </ul>
      </div>

      <img src={sideImage} alt="sidebar" className="sidebar-bottom-img" />

    </div>
  );
};

export default Sidebar;
